import React from 'react';
export function TermsConditions() {
  return <div className="prose prose-sm max-w-none text-[#3D3028]/80" data-id="element-281">
      <h3 className="text-lg font-semibold text-[#3D3028] mb-4" data-id="element-282">
        Términos y Condiciones
      </h3>

      <p className="mb-4" data-id="element-283">Última actualización: Diciembre 2024</p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-284">
        1. Aceptación de Términos
      </h4>
      <p className="mb-4" data-id="element-285">
        Al acceder y utilizar este curso, aceptas estar sujeto a estos términos
        y condiciones. Si no estás de acuerdo, no debes utilizar nuestros
        servicios.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-286">
        2. Acceso al Curso
      </h4>
      <p className="mb-4" data-id="element-287">
        Al completar tu compra, obtendrás acceso inmediato y de por vida al
        contenido del curso, incluyendo videos, materiales descargables y bonos
        exclusivos.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-288">
        3. Garantía de Devolución
      </h4>
      <p className="mb-4" data-id="element-289">
        Ofrecemos una garantía de devolución del 100% durante los primeros 7
        días después de tu compra. Si no estás satisfecha con el curso, puedes
        solicitar un reembolso completo sin preguntas.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-290">
        4. Propiedad Intelectual
      </h4>
      <p className="mb-4" data-id="element-291">
        Todo el contenido del curso, incluyendo videos, textos, imágenes y
        materiales descargables, está protegido por derechos de autor y es
        propiedad exclusiva de Master Hydra Gloss Lips™.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-292">
        5. Uso Permitido
      </h4>
      <p className="mb-4" data-id="element-293">
        El contenido del curso es para tu uso personal y educativo. No está
        permitido:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-294">
        <li data-id="element-295">Compartir tu acceso con terceros</li>
        <li data-id="element-296">Reproducir o distribuir el contenido</li>
        <li data-id="element-297">Revender o comercializar los materiales</li>
        <li data-id="element-298">Utilizar el contenido para crear cursos competidores</li>
      </ul>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-299">
        6. Limitación de Responsabilidad
      </h4>
      <p className="mb-4" data-id="element-300">
        El curso proporciona información educativa. Los resultados pueden variar
        según la práctica y dedicación individual. No garantizamos resultados
        específicos.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-301">
        7. Modificaciones
      </h4>
      <p className="mb-4" data-id="element-302">
        Nos reservamos el derecho de actualizar el contenido del curso y estos
        términos en cualquier momento. Los cambios significativos serán
        notificados a los usuarios activos.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-303">
        8. Jurisdicción
      </h4>
      <p className="mb-4" data-id="element-304">
        Estos términos se rigen por las leyes aplicables. Cualquier disputa será
        resuelta mediante arbitraje o en los tribunales competentes.
      </p>
    </div>;
}